<template>
  <div class="page page-serves">
    <div class="d-flex flex-column">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text" id="serve-search-icon-addon">
            <font-awesome-icon icon="search" size="1x" :style="{ color: 'gray' }" />
          </span>
        </div>
        <input
          type="text"
          class="form-control serve-search"
          placeholder="Поиск по марке, модели, рег. номеру"
          aria-label="Поиск по марке, модели, рег. номеру"
          aria-describedby="serve-search-icon-addon"
          @input="searchServe"
          :value="searchText"
        />
      </div>
    </div>
    <table class="table table-hover w-100 mt-3 d-none d-md-table">
      <TableSort :sorts="sorts" @sortsUpdate="loadWithSort" />
      <tbody>
        <tr v-for="car of cars" :key="car.id" @click="$router.push(`/serve/${car.id}`)">
          <td>
            <text-highlight class="highlighter" :queries="searchText">{{ car.brand }}</text-highlight>
          </td>
          <td>
            <text-highlight class="highlighter" :queries="searchText">{{ car.model }}</text-highlight>
          </td>
          <td>
            <text-highlight class="highlighter" :queries="searchText">{{ car.registration_plate }}</text-highlight>
          </td>
          <td>
            <ServiceState
              :distance="car.nextServiceRecord ? car.nextServiceRecord.distRemains : null"
              :interval="car.nextServiceRecord ? car.nextServiceRecord.interval : null"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <div class="mobile-table-view card mt-2 mb-2 p-2 d-md-none" v-for="car of cars" :key="car.id">
      <table v-if="cars.length > 0" class="table borderless">
        <tbody>
          <tr>
            <td style="border-top: none">Марка автомобиля</td>
            <td style="border-top: none">
              <text-highlight class="highlighter" :queries="searchText">{{ car.brand }}</text-highlight>
            </td>
          </tr>
          <tr>
            <td>Модель автомобиля</td>
            <td>
              <text-highlight class="highlighter" :queries="searchText">{{ car.model }}</text-highlight>
            </td>
          </tr>
          <tr>
            <td>Рег. номер</td>
            <td>
              <text-highlight class="highlighter" :queries="searchText">{{ car.registration_plate }}</text-highlight>
            </td>
          </tr>
          <tr>
            <td>Следующее ТО</td>
            <td>
              <ServiceState
                :distance="car.nextServiceRecord ? car.nextServiceRecord.distRemains : null"
                :interval="car.nextServiceRecord ? car.nextServiceRecord.interval : null"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <router-link
        :to="{ name: 'servePage', params: { carId: car.id } }"
        class="btn btn-primary btn-md create-serve ml-auto"
        >Подробно</router-link
      >
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { djsMixin } from '@/components/mixins/djsMixin'

export default {
  name: 'Serve',
  mixins: [djsMixin],
  props: {
    page: {
      type: String,
      default: () => '1'
    }
  },
  computed: {
    ...mapState('taxi/servecars', {
      cars: state => state.items,
      pageCount: state => state.pageCount,
      searchText: state => state.searchText,
      isLoading: state => state.isLoading
    })
  },
  beforeDestroy () {
    this.abortLoading()
  },
  data () {
    return {
      sorts: [
        {
          name: 'Марка автомобиля',
          storeName: 'servecar-brand',
          values: ['', 'brand', '-brand'],
          order: 0
        }, {
          name: 'Модель автомобиля',
          storeName: 'servecar-model',
          values: ['', 'model', '-model'],
          order: 1
        }, {
          name: 'Рег. номер',
          storeName: 'servecar-registration_plate',
          values: ['', 'registration_plate', '-registration_plate'],
          order: 2
        }, {
          name: 'Следующее ТО',
          storeName: 'servecar-nextService',
          values: ['', 'nextServiceDist', '-nextServiceDist'],
          order: 3
        }
      ]
    }
  },
  methods: {
    ...mapActions('taxi/servecars', [
      'loadItems',
      'setSearchText',
      'setSearch',
      'abortLoading',
      'removeItem',
      'setSorts'
    ]),
    searchServe (e) {
      this.setSearchText(e.target.value)
      this.setSearch({ key: 'brand', value: e.target.value })
      this.setSearch({ key: 'model', value: e.target.value })
      this.setSearch({ key: 'registration_plate', value: e.target.value })
      this.loadItems({ page: Number(this.page) })
    },
    leftUntil (planItem) {
      if (!this.car || !this.car.lastState || !this.car.lastState.totalOdometer) {
        return 'н/д о пробеге'
      }

      if (!planItem.total_odometer_stamp) {
        return 'н/д'
      }

      const odometerDiff = planItem.interval - (Math.ceil(this.car.lastState.totalOdometer.value / 1000) - planItem.total_odometer_stamp)

      switch (Math.sign(odometerDiff)) {
        case 1:
          return `осталось ${odometerDiff} км`
        case -1:
          return `просрочено на ${Math.abs(odometerDiff)} км`
        case 0:
          return 'осталось 0 км'
        case NaN:
          return 'н/д'
      }
    },
    loadWithSort (sorts) {
      this.setSorts(sorts)
      this.loadItems({ page: Number(this.page) })
    }
  }
}
</script>
<style lang="scss" scoped>
  @media screen and (max-width: 1199px) {
    .page {
      padding: 1rem;
    }
  }
  @media screen and (max-width: 576px) {
    .page {
      padding: 0.5rem;
    }
  }
  .page-serves .input-group-text {
    background-color: white;
    border-right: none;
  }
  .page-serves input {
    border-left: none;
  }
  .tablerow {
    cursor: pointer;
  }
  .overduerow {
    background-color: rgba(191, 84, 59, 0.13);
    &:hover {
      background-color: rgba(191, 84, 59, 0.2);
    }
  }
  .highlighter ::v-deep .text__highlight {
    border-radius: 0px;
    padding: 0.2em 0 0.2em 0;
    background: #fff2ae;
  }
</style>
